<template>
    <section class="section-outline">
        <mvtCollapse :disable="disableCollapse" :isActive="isActive">
            <template v-slot:header="collapsible">
                <h2 class="f2 text-bold">{{dpp.isLand ? molang('dpp.propertyEstimate.landValueCompsNew') : molang('dpp.propertyEstimate.homeValueCompsNew')}} <sub class="sub">for {{dpp.geo.address}}</sub></h2>
                <div class="f5 text-gray property-estimate-subtitle" v-if="dpp.permitAvm && getEstimateInfo && getEstimateInfo.value" v-show="collapsible.collapsed">
                    {{molang('dpp.estimate')}}
                    <span v-if="getEstimateInfo.value">{{$filters.formatFriendlyPrice(getEstimateInfo.value)}}</span>
                    <span v-if="getEstimatePriceRange">range {{getEstimatePriceRange}}</span>
                </div>
            </template>
            <template v-slot:default>
                <div class="grid xs-grid-cols-1 topGrid">
                    <div class="estimateCards grid xs-grid-cols-1 gap-1" v-if="dpp.permitAvm">
                        <div v-if="getEstimatePriceRange" class="m-b-2 estimate-price-range">
                            <div class="flex middle left">
                                <b class="text-bold f0" v-if="getEstimateInfo && getEstimateInfo.value">{{ $filters.formatFriendlyPrice(getEstimateInfo.value) }}</b>
                            </div>
                            <div class="f5 price-range">
                                <b class="text-bold">Range: {{ getEstimatePriceRange }} </b>
                                <div>
                                    <span class="text-gray">Last 30 days&nbsp;</span>
                                    <span v-if="priceChanged" :class="isIncrease ? 'text-safe' : 'text-danger'">{{ isIncrease ? '+' : '-' }}{{ $filters.formatFriendlyPrice(priceChanged) }}<i :class="isIncrease ? 'icon-send-ios' : 'icon-arrow-down-circle-filled'"></i></span>
                                </div>
                            </div>
                        </div>
                        <div v-if="dpp.permitAvm && getEstRentFee" class="estimate-rent f6">
                            <div>
                                <span class="text-bold">Rental est.: </span>
                                <span>{{ $filters.formatPrice(getEstRentFee.value) }}/month</span>
                            </div>
                            <div>
                                <span class="m-l-1 hidden-sm hidden-xs separator">&bull;</span>
                                <span class="text-bold" v-if="getEstRentFee.grm">Gross rent multiplier: </span>
                                <span>{{ getEstRentFee.grm }} {{ getEstRentFee.rate ? '- ' + getEstRentFee.rate : '' }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-else>We are not permitted to show value estimates for this property.</div>
                    <div v-if="hasChartData" class="mvt-estprice grid xs-grid-cols-1" :class="{open: isOpen}">
                      <div class="bg-default grid xs-grid-cols-1">
                          <mvtEstPriceChart :isMarket5YLoaded="isMarket5YLoaded" :dpp="dpp" :showDescription="false" v-if="glb.enableThirdPart"></mvtEstPriceChart>
                      </div>
                    </div>
                  <div class="paragraph f7" v-if="showNotSupportedByMLS()">
                      {{ molang('dpp.movotoPowered') }}
                  </div>
                </div>
            </template>
        </mvtCollapse>
    </section>
</template>
<script src="./property-estimate.js"></script>

<style lang="scss">
@use "./property-estimate.scss" as *;
</style>
